module.exports = __webpack_public_path__ + "static/media/04.Vanara Sena-ink.1a3c01c6.jpeg";